module.exports = __webpack_public_path__ + "img/file-upload-success.b1030013.svg";